import { useEffect } from 'react';
import { useFetcher } from 'react-router';
import { isbot } from 'isbot';
export default function useRegisterVehicleView() {
  const { submit } = useFetcher();

  useEffect(() => {
    // Don't register vehicle views for bots
    const userIsBot = isbot(navigator.userAgent || '');
    if (userIsBot) {
      return;
    }

    // Delay the POST request to try to avoid race condition of cookie setting in the browser since that is a synchronous operation.
    setTimeout(() => {
      submit(
        {
          intent: 'register_vehicle_view',
        },
        {
          method: 'post',
        }
      );
    }, 1000);
    /**
     * This hook should only run on mount so that we register only one view per page visit/refresh.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
